import React from "react";
import InventarioReporte from "./InventarioReporte";
export default function ListaDispositivos() { return <InventarioReporte kind="dispositivos" />; }
